import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateresult',
    standalone: false
})
export class TranslateresultPipe implements PipeTransform {

    transform(value: string): string {
      const translationMap = {
        'No Clinical Findings': 'בדיקה תקינה',
        'Clinical Findings': 'ממצאים בעלי חשיבות קלינית',
        'Urgent Clinical Findings': 'ממצאים קלינים דחופים'
      };
  
      return translationMap[value] || value;
    }
  

}
